<template>
  <header class="header" :class="{ 'is-scrolled': $root.windowTop > 8 }">
    <div class="container header__inner">
      <a
        class="header__logo"
        href="/"
        aria-label="Formal Crypto"
        @click.prevent="$root.goTo('#top')"
      >
        <svg width="160" height="19" aria-hidden="true">
          <use xlink:href="#logo"></use>
        </svg>
      </a>
      <nav class="header__nav" aria-label="Main">
        <a
          v-for="link in links"
          :key="link.id"
          class="header__link"
          :class="{ 'is-active': active === link.id }"
          :href="`#${link.id}`"
          @click.prevent="$root.goTo(`#${link.id}`)"
        >
          {{ link.title }}
        </a>
      </nav>
      <a
        class="button button--small button--outline header__cta"
        href="#contact"
        @click.prevent="$root.goTo('#contact')"
      >
        Contact us
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      active: '',
      links: [
        { id: 'about', title: 'About' },
        { id: 'services', title: 'Services' },
        { id: 'projects', title: 'Projects' },
        { id: 'contact', title: 'Contact' }
      ]
    }
  },
  mounted() {
    if (!('IntersectionObserver' in window)) {
      return
    }
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.active = entry.target.id
          } else if (this.active === entry.target.id) {
            this.active = ''
          }
        })
      },
      { rootMargin: '-45% 0px -50% 0px' }
    )
    this.$nextTick(() => {
      this.links.forEach(link => {
        const section = document.getElementById(link.id)
        if (section) {
          this.observer.observe(section)
        }
      })
    })
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>
